<template>
  <div class="centrarBody transparent">
    <div class="centrarBody transparent">
      <br />
      <v-row>
        <v-col cols="9">
          <v-card class="elevation-0 transparent">
            <v-row align="center" justify="center">
              <h5>Bienvenido: <b style="color:#5DC00A; font-weight: 700 ">{{cuenta.nombre}} {{cuenta.apellidopaterno}} {{cuenta.apellidomaterno}}</b></h5>
            </v-row>
          </v-card>
        </v-col>
        <v-col cols="3">
          <v-row align="center" justify="end">
            <v-btn :x-large="$vuetify.breakpoint.smAndUp" class="btn-new" color="#5DC00A" @click="cerrarSesion()">
              <div class="d-none d-md-block white--text">Cerrar sesión</div>
              <v-icon :small="$vuetify.breakpoint.xsOnly" class="ml-2" color="#FFFFFF">mdi-logout</v-icon>
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="12" md="6" lg="6" xl="6">
          <v-card class="elevation-0 transparent">
            <h5>Número de créditos: <b style="color:#5DC00A; font-weight: 700 ">{{cuenta.numcreditos}}</b></h5>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" lg="6" xl="6">
          <v-card class="elevation-0 transparent">
            <h5>RFC: <b style="color:#5DC00A; font-weight: 700 ">{{cuenta.rfc}}</b></h5>
          </v-card>
        </v-col>
        <v-col cols="12" md="6" lg="6" xl="6">
          <v-card class="elevation-0 transparent">
            <v-row align="center" justify="start">
            <h5>Saldo total: <b style="color:#5DC00A; font-weight: 700 ">{{cuenta.saldototal | currency}}</b>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn class="mb-1" color="#5DC00A" icon v-on="on" @click="recargarDatosTabla(0)">
                    <v-icon>mdi-rotate-3d-variant</v-icon>
                  </v-btn>
                </template>
                <span>Actualizar datos</span>
              </v-tooltip>
            </h5>
          </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-divider></v-divider>
    <br />
      <v-data-table :headers="headers" :items="cuenta.creditos" class="elevation-10 mb-10" locale="es-mx">
        <template v-slot:item.descuento="{ item }">{{item.descuento | currency}}</template>
        <template v-slot:item.saldoactual="{ item }">{{ item.saldoactual | currency }}</template>
        <template v-slot:item.saldovencido="{ item }">
          <v-chip :color="getColor(item.saldovencido)" dark>{{item.saldovencido | currency}}</v-chip>
        </template>
        <template v-slot:item.informacion="{ item }">
          <div class="text-center">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn color="#5DC00A" icon v-on="on">
                  <v-icon>mdi-information</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item @click="mostrarEstadoCuenta(item.idcredito)">
                  <v-list-item-title>Estado de cuenta</v-list-item-title>
                </v-list-item>
                <v-list-item @click="mostrarOxxoPay(item)">
                  <v-list-item-title>Pagar en Oxxo</v-list-item-title>
                </v-list-item>
                <v-list-item @click="pagarConTarjeta(item)">
                  <v-list-item-title>Pagar con tarjeta</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
      </v-data-table>
      <v-divider></v-divider>
      <div class="text-center">
        <v-dialog v-model="dialogFichaOxxo" max-width="600" scrollable>
          <v-card>
            <v-card-text>
              <div>
                <FichaOxxo id="fiox"></FichaOxxo>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red" class="white--text" @click="dialogFichaOxxo = false">Cancelar</v-btn>
              <v-btn color="#008230" class="white--text" @click="printDiv('fiox')">Imprimir</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
      <div>
        <v-dialog v-model="dialogPagoTarjeta" max-width="700" persistent>
          <PagoTarjeta></PagoTarjeta>
        </v-dialog>
      </div>
      <div>
        <LoaderDialog></LoaderDialog>
        <DialogoMensaje></DialogoMensaje>
        <DialogoPago></DialogoPago>
      </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import FichaOxxo from "@/components/FichaOxxoPay.vue";
import router from "@/router/index.js";
import LoaderDialog from "@/components/LoaderDialog.vue";
import DialogoMensaje from "@/components/DialogoMensaje.vue";
import PagoTarjeta from "@/components/PagoTarjeta.vue";
import DialogoPago from "@/components/DialogoPago.vue"

export default {
  name: "Home",
  components: {
    FichaOxxo,
    LoaderDialog,
    DialogoMensaje,
    PagoTarjeta,
    DialogoPago
  },
  computed: {
    ...mapState(["cuenta", "dialogPagoTarjeta"])
  },
  mounted: function() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });	
  },
  watch: {
    dialogPagoTarjeta() {
      this.switchDialogoChat();
    },
    dialogFichaOxxo() {
      console.log('change in dialog oxxo');
      this.switchDialogoChat();
    }
  },
  data() {
    return {
      headers: [
        { text: "Información", sortable: false, value: "informacion" },
        { text: "Folio", sortable: false, value: "folio" },
        { text: "Estatus", value: "estatus" },
        { text: "Fecha de autorización", value: "fechaventa" },
        { text: "Descuento", value: "descuento" },
        { text: "Plazo", value: "plazo" },
        { text: "Periodicidad", value: "periodicidad" },
        { text: "Saldo", value: "saldoactual" },
        { text: "Saldo vencido", value: "saldovencido" },
        { text: "Avance (%)", value: "porcavanceformat" }
      ],
      dialogFichaOxxo: false
    };
  },
  methods: {
    ...mapActions(["mostrarEstadoCuenta", "recargarDatosTabla"]),
    getColor(sueldo) {
      if (sueldo < 1) return "transparent black--text";
      else return "red white--text";
    },
    switchDialogoChat() {
      var chat = document.getElementById('calixta-badge');
      chat.style.display = (chat.style.display == 'block') ? 'none' : 'block';
    },
    pagarConTarjeta: function(evt) {
      var pagoDescuentoV = evt.descuento;
      var pagoSaldoTotal = evt.saldoactual;
      if(pagoDescuentoV>pagoSaldoTotal){
        pagoDescuentoV = pagoSaldoTotal;
      }
      var datosPagoTarjeta = {
        idCredito : evt.idcredito,
        pagoDescuento : pagoDescuentoV,
        pagoSaldo : evt.saldoactual,
        pagoVencido: evt.saldovencido
      }
      this.$store.commit("setVisiblePagoTarjeta", true);
      this.$store.commit("setContenidoDialogPagoTarjeta", datosPagoTarjeta);
    },
    mostrarOxxoPay: function(evt) {
      var datosOxxo = {
        monto: evt.descuento,
        referencia: evt.referenciaoxxo,
        codigoBarras: evt.urlcodigobarras
      };
      this.$store.commit("setDatosOxxo", datosOxxo);
      this.dialogFichaOxxo = true;
    },
    cerrarSesion() {
      this.$store.commit("guardarCuenta", null);
      sessionStorage.clear();
      router.push({ name: "IniciarSesion" });
    },
    printDiv(nombreDiv) {
      var ficha = document.getElementById(nombreDiv);
      var ventana = window.open("", "PRINT", "height=400,width=600");
      ventana.document.write("<html><head><title>Ficha OxxoPay</title>");
      ventana.document.write(
        '<style type=text/css>   body {font-size: 14px;}h3 {margin-bottom: 10px;font-size: 15px;font-weight: 600;text-transform: uppercase;}.opps {width: 496px;border-radius: 4px;box-sizing: border-box;padding: 0 45px;margin: 40px auto;overflow: hidden;border: 1px solid #b0afb5;font-family: "Open Sans", sans-serif;color: #4f5365;}.opps-reminder {position: relative;top: -1px;padding: 9px 0 10px;font-size: 11px;text-transform: uppercase;text-align: center;color: #ffffff;background: #000000;}.opps-info {margin-top: 26px;position: relative;}.opps-info:after {visibility: hidden;display: block;font-size: 0;content: " ";clear: both;height: 0;}.opps-brand {width: 45%;float: left;}.opps-brand img {max-width: 150px;margin-top: 2px;}.opps-ammount {width: 55%;float: right;}.opps-ammount h2 {font-size: 36px;color: #000000;line-height: 24px;margin-bottom: 15px;}.opps-ammount h2 sup {font-size: 16px;position: relative;top: -2px;}.opps-ammount p {font-size: 10px;line-height: 14px;}.opps-reference {margin-top: 14px;}h1 {font-size: 27px;color: #000000;text-align: center;margin-top: -1px;padding: 6px 0 7px;border: 1px solid #b0afb5;border-radius: 4px;background: #f8f9fa;}.opps-instructions {margin: 32px -45px 0;padding: 32px 45px 45px;border-top: 1px solid #b0afb5;background: #f8f9fa;}ol {margin: 17px 0 0 16px;}li + li {margin-top: 10px;color: #000000;}a {color: #1155cc;}.opps-footnote {margin-top: 22px;padding: 22px 20 24px;color: #108f30;text-align: center;border: 1px solid #108f30;border-radius: 4px;background: #ffffff;}</style>'
      );
      ventana.document.write("</head><body>");
      ventana.document.write(ficha.innerHTML);
      ventana.document.write("</body></html>");
      ventana.window.onafterprint = function () {
        ventana.window.close();
      };
      ventana.document.close();
      ventana.focus();
      ventana.print();
      //ventana.close();
      //ventana = null;
      //ficha = null;
    }
  },
  beforeCreate() {
    var cuenta = JSON.parse(sessionStorage.getItem("cuenta"));
    if (cuenta == null) {
      this.$store.commit("guardarCuenta", cuenta);
      router.push({ name: "IniciarSesion" });
    } else {
      this.$store.commit("guardarCuenta", cuenta);
    }
  }
};
</script>

<style scoped>
.centrarBody {
  padding-left: 5%;
  padding-right: 5%;
  margin-bottom: 50px;
}
.ajustarBoton {
  text-align: right;
  padding-left: 11%;
}
</style>
